import { registerImages, Source } from '@bonanza-social/moonlight';
import lobbyWidgetIcon from './lobbyWidgetIcon.webp';
import location from './location.webp';
import reward from './reward.webp';

const images = { location, lobbyWidgetIcon, reward };

registerImages('onboarding', images);

declare global {
  interface RegisteredImages {
    onboarding: Record<keyof typeof images, Source>;
  }
}
